import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import type { JSX, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Text, Tooltip } from '@feathr/components';

import * as styles from './DomainField.css';

interface IProps {
  children?: ReactNode;
  label: string;
  tooltip?: ReactNode;
}

function DomainField({ children, label, tooltip }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.label}>
        <Text variant={'defaultMedium'}>{label}</Text>
        {tooltip && (
          <Tooltip focusable={true} title={tooltip}>
            <Icon
              aria-hidden={false}
              aria-label={t('More information')}
              icon={faInfoCircle}
              size={5}
              theme={'neutral'}
            />
          </Tooltip>
        )}
      </div>
      <div className={styles.value}>{children}</div>
    </div>
  );
}

export default DomainField;
